module.exports = __webpack_public_path__ + "media/B.5204db3c.mp3";